import { ACTIVE, PROCESSING, NEEDS_ATTENTION, INACTIVE } from "../constants";

export const selectFeedsByStatus = (feeds, status) =>
  feeds.filter(feed => feed.status === status);

export const selectFeedsByClient = (feeds, clientId) =>
  feeds.filter(feed => feed.client_id === clientId);

export const getAllActiveFeedsByClient = (feeds, clientId) => {
  const clientFeeds = selectFeedsByClient(feeds, clientId);
  const activeFeeds = selectFeedsByStatus(clientFeeds, ACTIVE);
  const processingFeeds = selectFeedsByStatus(clientFeeds, PROCESSING);
  const needsAttentionFeeds = selectFeedsByStatus(clientFeeds, NEEDS_ATTENTION);
  return activeFeeds.concat(processingFeeds).concat(needsAttentionFeeds);
};

export const getAllInactiveFeedsByClient = (feeds, clientId) => {
  const clientFeeds = selectFeedsByClient(feeds, clientId);
  return selectFeedsByStatus(clientFeeds, INACTIVE);
};

export const selectAllClients = store =>
  Object.values(store.entities.clients.byId);

export const selectAllFeeds = store => Object.values(store.entities.feeds.byId);

export const selectAllBrands = store =>
  Object.values(store.metadata.brands.byId).map(b => ({
    value: b.brand_id.toString(),
    label: b.name
  }));

export const selectProgressByReportId = (store, feedId) => {
  const progress = Object.values(store.entities.progress.byId);
  return progress.filter(progress => progress.report_id === feedId);
};
